export class ActivityFinishSuccesfully {

    requestId: number;
    activityId: number;
    activityResultId: number;
    newFinishDateFact: Date;
}